<template>
  <div>
    <el-timeline-item
      v-if="content"
      :icon="icon"
      :type="type"
      :color="color"
      size="large"
      :timestamp="formatDate(activity.createdOn)"
    >
      <div v-html="formattedActivityText" class=""></div>
    </el-timeline-item>
  </div>
</template>

<script>
import ActivitiesTimelineMixin from "@/components/ActivitiesView/ActivitiesTimelineMixin.vue";
export default {
  mixins: [ActivitiesTimelineMixin],
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  methods: {
    async generateReadableUpdateMortgage() {
      let contentHtml = ``;
      for (let update of this.updates) {
        contentHtml = this.generateRegularActivityString(contentHtml, update);
      }
      this.setReadableUpdateProps(contentHtml);
    }
  },
  watch: {
    activity: {
      async handler() {
        this.content = "";
        this.icon = "";
        this.type = "";
        this.link = {};
        this.color = "";
        switch (this.activity.name) {
          case "ADD_MORTGAGE_SUCCESS":
            this.generateReadableGeneric({
              content: "added a new mortgage.",
              icon: "el-icon-office-building",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "ADD_MORTGAGE_FAILURE":
            this.generateReadableFailGeneric({
              content: "failed to add a mortgage.",
              icon: "el-icon-office-building",
              link: this.accountTypeFormatted
            });
            break;
          case "UPDATE_MORTGAGE_SUCCESS":
            await this.generateReadableUpdateMortgage();
            break;
          case "UPDATE_MORTGAGE_FAILURE":
            this.generateReadableFailGeneric({
              content: "failed to update mortgage.",
              icon: "el-icon-office-building",
              link: this.accountTypeFormatted
            });
            break;
          case "DELETE_MORTGAGE_SUCCESS":
            this.generateReadableGeneric({
              content: "deleted a mortgage.",
              icon: "el-icon-office-building",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "DELETE_MORTGAGE_FAILURE":
            this.generateReadableFailGeneric({
              content: "failed to delete mortgage.",
              icon: "el-icon-office-building",
              link: this.accountTypeFormatted
            });
            break;
          case "SCREEN_VIEW":
            this.generateReadableGeneric({
              content: "visited the Mortgages page.",
              icon: "el-icon-office-building",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
        }
      },
      immediate: true
    }
  }
};
</script>

<style></style>
